<div class="principal-cont">
  @if (canViewDashboardStats()) {
  <div class="polizas-cont">
    @for(poliza of polizas; track $index) {
    <div class="poliza-cont">
      <h1>
        {{
            poliza.activas?.[1]?.monto ||
            poliza.prima?.[1]?.monto ||
            poliza.renovadas?.[1]?.monto
        }}
      </h1>
      <p>
        {{
            poliza.activas?.[0]?.name ||
            poliza.prima?.[0]?.name ||
            poliza.renovadas?.[0]?.name
        }}
      </p>
    </div>
    } @empty {
    <div class="poliza-cont">
      <h1>0</h1>
      <p>No hay polizas activas</p>
    </div>
    }
  </div>
  }

  <div class="carousel-cont">
    <a [href]="url" target="_blank" (click)="watchInstructive()">
      <img src="./assets/carousel-02.jpg" alt="" />
    </a>
  </div>

  @if (canViewDashboardStats()) {
  <div class="generales-cont">
    <div class="movimientos-cont">
      <h1 class="title-h4 mb-4">Movimientos recientes</h1>
      <div class="movimientos-cont-inner">
        @for(movimiento of movimientos; track $index) {
        <div class="movimiento-card">
          <div class="movimiento-items">
            <div class="movimiento-item">
              <p>Póliza no.</p>
              <label>{{ movimiento.polizaNo }}</label>
            </div>
            <div class="movimiento-item">
              <p>Prima total</p>
              <label>{{ movimiento.primaTotalRD }}</label>
            </div>
          </div>
          <div class="movimiento-items mt-2">
            <div class="movimiento-item">
              <p>Tipo de transacción</p>
              <label>{{ movimiento.tipoTransaccion }}</label>
            </div>
            @if(movimiento.monto && !movimiento.monto.includes('$ 0.00')) {
            <div class="movimiento-item">
              <p>Monto</p>
              <label>{{ movimiento.monto }}</label>
            </div>
            }
          </div>
        </div>
        } @empty {
        <div class="movimiento-card">
          <p>No hay movimientos recientes</p>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
